export default __webpack_public_path__ + "static/media/Saturday_07.647ee642.png";